var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"97202e17662e2041f81031fb610a57c11eaf7e47"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["stackscout-web@stackscout"]={id:"97202e17662e2041f81031fb610a57c11eaf7e47"};
      